import React from "react";
import {
  AppWindow,
  ClipboardCheck,
  GitBranch,
  MonitorCog,
  SearchCheck,
  Workflow,
} from "lucide-react";
import "./Services.css";

const services = [
  {
    icon: SearchCheck,
    title: "Analyse des besoins",
    description:
      "Clarifiez les attentes de vos équipes, vos priorités et les contraintes de votre environnement informatique.",
  },
  {
    icon: MonitorCog,
    title: "Conseil en systèmes",
    description:
      "Prenez du recul sur vos systèmes existants et identifiez des pistes d'évolution adaptées à votre activité.",
  },
  {
    icon: AppWindow,
    title: "Conseil logiciel",
    description:
      "Évaluez les solutions logicielles selon vos usages, vos besoins fonctionnels et votre organisation.",
  },
  {
    icon: GitBranch,
    title: "Étude des solutions",
    description:
      "Comparez les options possibles pour avancer avec une vision plus claire des choix à votre disposition.",
  },
  {
    icon: Workflow,
    title: "Organisation des outils",
    description:
      "Réfléchissez à la place de vos outils numériques dans vos processus et à leur cohérence au quotidien.",
  },
  {
    icon: ClipboardCheck,
    title: "Accompagnement de projet",
    description:
      "Structurez les étapes de votre réflexion informatique et gardez le cap sur vos objectifs.",
  },
];

function Services() {
  return (
    <section id="services" className="services section">
      <div className="container">
        <p className="section-kicker">Notre expertise</p>
        <h3 className="section-title">Un accompagnement adapté à chaque étape.</h3>
        <div className="services-grid">
          {services.map(({ icon: Icon, title, description }, index) => (
            <article
              className="service-card"
              key={title}
              style={{ "--service-index": index }}
            >
              <span className="service-number" aria-hidden="true">
                <Icon strokeWidth={1.8} />
              </span>
              <h4>{title}</h4>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
